import { Flex } from 'primitives/Flex'

interface BannerLayoutProps {}
export const BannerLayout: React.FC<BannerLayoutProps> = ({ children }) => {
  return (
    <Flex
      css={{
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        '& > :not(:first-child)': {
          marginTop: '2px',
        },
      }}
    >
      {children}
    </Flex>
  )
}
